import React, { useEffect, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { Typography } from "@material-ui/core";
import { useSearchParams } from "react-router-dom";
import { PrimaryColor } from "../../../shared/styles/colors";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import TagGroupModal from "./TagGroupModal";
import TagGroup from "../../../model/tagGroup";
import useStyles from "./styles";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35rem",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  "@media (max-width: 640px)": {
    width: "80%",
  },
};

interface Props {
  tagGroup: TagGroup;
  resetList: () => void;
  onOpen: (id?: string) => void;
  onClose: () => void;
}

const TagGroupDetailModal = ({
  tagGroup,
  resetList,
  onOpen,
  onClose,
}: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleOpen = () => {
    setOpen(true);
    if (onOpen) {
      onOpen(tagGroup.id?.toString());
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    const groupId = searchParams.get("groupId");
    if (!open && groupId && groupId === tagGroup.id?.toString()) {
      handleOpen();
    }
  }, [searchParams]);

  return (
    <div>
      <Button onClick={handleOpen}>
        <MoreVertIcon sx={{ color: PrimaryColor }} />
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "auto" }}
      >
        <Box sx={style}>
          <div className={classes.headerDiv}>
            <Typography className={classes.title}>Group info</Typography>
            <div className={classes.headerSubDiv}>
              <TagGroupModal tagGroup={tagGroup} resetList={resetList} />
              <Button onClick={handleClose} sx={{ color: "black" }}>
                <CloseIcon />
              </Button>
            </div>
          </div>
          <hr />
          <div className={classes.form}>
            <div className={classes.inputGroup}>
              <Typography className={classes.detailLabel}>Name</Typography>
              <Typography className={classes.detailValue}>
                {tagGroup.name}
              </Typography>
            </div>
            <div className={classes.inputGroup}>
              <Typography className={classes.detailLabel}>
                Description
              </Typography>
              <Typography className={classes.detailValue}>
                {tagGroup.description}
              </Typography>
            </div>
            <div className={classes.inputGroup}>
              <Typography className={classes.detailLabel}>Color</Typography>
              <Typography
                className={classes.detailValue}
                style={{ color: tagGroup.color }}
              >
                {tagGroup.color}
              </Typography>
            </div>
            <div className={classes.inputGroup}>
              <Typography className={classes.detailLabel}>Tags</Typography>
              <div className={classes.tagsContainer}>
                {tagGroup.TagGroupItems &&
                  tagGroup.TagGroupItems.map((item) => (
                    <span key={item.id} className={classes.tagBadge}>
                      {item.Tag.name}
                    </span>
                  ))}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default TagGroupDetailModal;
